/**
 * @author vishwadeep.kapoor
 * @Date: 2018-12-13 13:13:07
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2021-01-05 15:44:52
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_CARD_DATA_YSC,
  SET_CARD_BLOCK_SUCCESS,
  SET_REPORT_SUCCESS,
  SET_CARD_REMOVE_SUCCESS,
  SET_POS_OTP_SEND_SUCCESS,
  SET_CARD_PIN_RESET_SUCCESS,
  SET_REQUEST_INTERNET_PIN,
  NETWORKCARD_CONSTANTS,
  SET_REPORT_STATEMENT_SUCCESS,
  SET_NSDL_M2P_STATEMENT_SUCCESS,
  SET_NSDL_ISG_STATEMENT_SUCCESS,
  SET_REPORT_SUCCESS_INDUSIND,
  SET_YES_BANK_WEARABLE_FAQ_SUCCESS,
  SET_NSDL_M2P_REPLACE_CARD_SUCCESS,
  SET_NSDL_M2P_BLOCK_CARD_SUCCESS,
  WALLET_TO_IMPS_TRANSFER_SUCCESS,
  SET_IPIN_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  SET_IPIN_OTP_SUCCESS,
  UNLOCK_CARD_OTP_SUCCESS,
  YBL_DELETE_BENEFICIARY_SUCCESS,
  GET_OTP_SUCCESS,
  SET_CHANNEL_FLAG_SUCCESS,
  FETCH_CARD_DATA_YBL,
  FETCH_CARD_DATA_NSDL,
} from './constants';

const initialState = fromJS({
  transactions: {},
  cardData: {},
  cardBlockResponse: {},
  walletToImpsSuccess: {},
  isLoading: false,
  isOtpSend: {},
  isSendReport: false,
  isCardRemove: false,
  isPosOtpSend: false,
  isPinResetSuccess: false,
  unlockCardOtpSuccess: {},
  requestInternetPin: {},
  complainTypeList: { status: false },
  complainList: { status: false },
  complainResponse: { status: false },
  beneficiaryUpdate: {},
  beneficiaryCreate: {},
  beneficiaryView: {},
  nsdlfundtransfer: { status: false },
  nsdlfundtransferlist: { status: false },
  nsdlBeneficiaryUpdate: { status: false },
  nsdlfundtransferview: { status: false },
  generateOtpNsdl: { status: false },
  isSendRequestStatement: { status: false },
  isNsdlM2pStatement: {},
  isNsdlIsgStatement: {},
  isIndusindStatement: {},
  isWearableFaqSuccess: { status: false },
  replaceCardM2pSuccess: {},
  cardBlockResponseM2p: {},
  yblVerifyLimitOtpSuccess: { status: false },
  beneficiariesList: {},
  yblOtpSuccess: {},
  ybl_otp_verified: {},
  setIpinSuccess: { status: false },
  resetPasswordSuccess: { status: false },
  ipinOtpSuccess: { status: false },
  yblDeleteBeneficiarySuccess: {},
  getOtpSuccess: {},
  setChannelFlagSuccess: {},
  setFundTransfer: {},
  cardDataYsc: {},
  cardDataYbl: {},
  cardDataNsdl: {},
  setChannelFlagData: {},
});

function networkCardsReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case DEFAULT_ACTION:
      return state
        .set('isLoading', payload);
    case FETCH_CARD_DATA_YSC:
      return state
        .set('cardDataYsc', fromJS(action.payload))
        .set('isLoading', false);
    case FETCH_CARD_DATA_YBL:
      return state
        .set('cardDataYbl', fromJS(action.payload))
        .set('isLoading', false);
    case FETCH_CARD_DATA_NSDL:
      return state
        .set('cardDataNsdl', fromJS(action.payload))
        .set('isLoading', false);
    case FETCH_TRANSACTIONS_SUCCESS:
      return state
        .set('transactions', fromJS(payload))
        .set('isLoading', false);
    case SET_CARD_BLOCK_SUCCESS:
      return state
        .set('cardBlockResponse', fromJS(payload))
        .set('isOtpSend', fromJS(payload))
        .set('isLoading', false);
    case SET_REPORT_SUCCESS:
      return state
        .set('isSendReport', payload)
        .set('isLoading', false);
    case SET_CARD_REMOVE_SUCCESS:
      return state
        .set('isCardRemove', payload)
        .set('isLoading', false);
    case SET_POS_OTP_SEND_SUCCESS:
      return state
        .set('isPosOtpSend', payload)
        .set('isLoading', false);
    case SET_CARD_PIN_RESET_SUCCESS:
      return state
        .set('isPinResetSuccess', payload.isSuccess)
        .set('isLoading', payload.isLoading || false);
    case SET_REQUEST_INTERNET_PIN:
      return state
        .set('requestInternetPin', fromJS(payload))
        .set('isLoading', false);
    case SET_REPORT_STATEMENT_SUCCESS:
      return state
        .set('isSendRequestStatement', fromJS(payload))
        .set('isLoading', false);
    case SET_NSDL_M2P_STATEMENT_SUCCESS:
      return state
        .set('isNsdlM2pStatement', fromJS(payload))
        .set('isLoading', false);
    case SET_NSDL_ISG_STATEMENT_SUCCESS:
      return state
        .set('isNsdlIsgStatement', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_COMPLAIN_TYPE_LIST:
      return state
        .set('complainTypeList', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_COMPLAIN_LIST:
      return state
        .set('complainList', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_COMPLAIN_CREATE:
      return state
        .set('complainResponse', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_BENEFICIARIES_LIST:
      return state
        .set('beneficiariesList', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_BENEFICIARIES_CREATE:
      return state
        .set('beneficiaryUpdate', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_BENEFICIARIES_CREATE_NEW:
      return state
        .set('beneficiaryCreate', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_BENEFICIARY_VIEW:
      return state
        .set('beneficiaryView', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_NSDL_BENEFICIARIES_CREATE:
      return state
        .set('nsdlfundtransfer', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_NSDL_BENEFICIARY_VIEW:
      return state
        .set('nsdlfundtransferview', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_NSDL_BENEFICIARIES_LIST:
      return state
        .set('nsdlfundtransferlist', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_NSDL_BENEFICIARIES_UPDATE:
      return state
        .set('nsdlBeneficiaryUpdate', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_GENERATE_OTP_NSDL:
      return state
        .set('generateOtpNsdl', fromJS(payload))
        .set('isLoading', false);
    case SET_REPORT_SUCCESS_INDUSIND:
      return state
        .set('isIndusindStatement', fromJS(payload))
        .set('isLoading', false);
    case SET_YES_BANK_WEARABLE_FAQ_SUCCESS:
      return state
        .set('isWearableFaqSuccess', fromJS(payload))
        .set('isLoading', false);
    case SET_NSDL_M2P_REPLACE_CARD_SUCCESS:
      return state
        .set('replaceCardM2pSuccess', fromJS(payload))
        .set('isLoading', false);
    case SET_NSDL_M2P_BLOCK_CARD_SUCCESS:
      return state
        .set('cardBlockResponseM2p', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_YBL_VERIFY_LIMIT_OTP:
      return state
        .set('yblVerifyLimitOtpSuccess', fromJS(payload))
        .set('isLoading', false);
    case WALLET_TO_IMPS_TRANSFER_SUCCESS:
      return state
        .set('walletToImpsSuccess', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_YBL_OTP_SUCCESS:
      return state
        .set('yblOtpSuccess', fromJS(action.payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_YBL_OTP_VERIFIED: {
      return state
        .set('ybl_otp_verified', fromJS(action.payload))
        .set('isLoading', false);
    }
    case SET_IPIN_SUCCESS:
      return state
        .set('setIpinSuccess', fromJS(payload))
        .set('isLoading', false);
    case RESET_PASSWORD_SUCCESS:
      return state
        .set('resetPasswordSuccess', fromJS(payload))
        .set('isLoading', false);
    case SET_IPIN_OTP_SUCCESS:
      return state
        .set('ipinOtpSuccess', fromJS(payload))
        .set('isLoading', false);
    case UNLOCK_CARD_OTP_SUCCESS:
      return state
        .set('unlockCardOtpSuccess', fromJS(payload))
        .set('isLoading', false);
    case YBL_DELETE_BENEFICIARY_SUCCESS:
      return state
        .set('yblDeleteBeneficiarySuccess', fromJS(payload))
        .set('isLoading', false);
    case GET_OTP_SUCCESS:
      return state
        .set('getOtpSuccess', fromJS(payload))
        .set('isLoading', false);
    case SET_CHANNEL_FLAG_SUCCESS:
      return state
        .set('setChannelFlagSuccess', fromJS(payload))
        .set('isLoading', false);
    case NETWORKCARD_CONSTANTS.SET_YES_BANK_TRANSFER:
      return state
        .set('setFundTransfer', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default networkCardsReducer;



// WEBPACK FOOTER //
// client/containers/NetworkCards/reducer.js